import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation } from "@tanstack/react-query";

export const OPEN_POSITION_FULL_SYNC_API_PATH = "/v1/open-position/full-sync" as const;

export type OpenPositionFullSyncResponse =
  paths[typeof OPEN_POSITION_FULL_SYNC_API_PATH]["post"]["responses"][202] extends {
    content: infer Content;
  }
    ? Content[keyof Content]
    : void;

export function useOpenPositionFullSyncMutation() {
  return useMutation<OpenPositionFullSyncResponse, Error>({
    mutationFn: async (): Promise<OpenPositionFullSyncResponse> => {
      await alphartisApiAxios.post<OpenPositionFullSyncResponse>(OPEN_POSITION_FULL_SYNC_API_PATH);
    },
  });
}
